"use client";

import { usePathname, useSearchParams } from "next/navigation";
import posthog from "posthog-js";
import { useEffect, useRef } from "react";

export function PosthogPageviewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const prevUrlRef = useRef<string | null>(null);
  const search = searchParams?.toString();

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    if (!pathname) {
      return;
    }

    const url = search ? `${pathname}?${search}` : pathname;

    if (prevUrlRef.current === url) {
      return;
    }
    prevUrlRef.current = url;
    posthog.capture("$pageview", {
      $current_url: window.location.href,
      pageview_source: "custom_tracker",
    });
  }, [pathname, search]);

  return null;
}
